module.exports = __webpack_public_path__ + "img/back-img-orange.f209c222.png";